import { setLoading } from "../redux/slices/configuracoes/configuracoesSlice";
import api from "../util/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toastError, toastSucess } from "../util/toast";
import { setModalCadastrarTipoDocumento, setModalDeletarTipoDocumento } from "../redux/slices/tipoDocumento/tipoDocumentoSlice";

export const cadastrarTipoDocumento = createAsyncThunk("/TipoDocumento/CadastrarTipoDocumento", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.post("/TipoDocumento/CadastrarTipoDocumento", payload.value);
    toastSucess("Tipo de documento cadastrado com sucesso");
    dispatch(setModalCadastrarTipoDocumento(false));
    dispatch(setLoading(false));

    dispatch(buscarTipoDocumento(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const buscarTipoDocumento = createAsyncThunk("/TipoDocumento/BuscarTipoDocumento", async (pesquisar: string | null) => {
  try {
    const data = await api.get("/TipoDocumento/BuscarTipoDocumento", {
      params: { pesquisar: pesquisar },
    });
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const atualizarTipoDocumento = createAsyncThunk("/TipoDocumento/AtualizarTipoDocumento", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.put("/TipoDocumento/AtualizarTipoDocumento", payload.value);
    toastSucess("Tipo de documento atualizado com sucesso");
    dispatch(setModalCadastrarTipoDocumento(false));
    dispatch(setLoading(false));

    dispatch(buscarTipoDocumento(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const deletarTipoDocumento = createAsyncThunk("/TipoDocumento/DeletarTipoDocumento", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.delete("/TipoDocumento/DeletarTipoDocumento", {
      params: { id: payload.value },
    });
    toastSucess("Tipo de documento removido com sucesso");
    dispatch(setModalDeletarTipoDocumento(false));
    dispatch(setLoading(false));

    dispatch(buscarTipoDocumento(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});
